import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteModoEnvioBoletoModule } from './boleto';
import { NovoCondicaoPagamentoSelectModule } from '../../../../domains/shared/components/novo-condicao-pagamento-select/novo-condicao-pagamento-select.module';
import { ClientePrazoPagamentoModule } from '../prazo-pagamento';
import { FormaPagamentoSelectModule } from '../../../forma-pagamento/select/forma-pagamento-select.module';

import { ClienteFinanceiroFormComponent } from './form';

@NgModule({
    imports: [
        SharedModule,
        ClienteModoEnvioBoletoModule,
        NovoCondicaoPagamentoSelectModule,
        ClientePrazoPagamentoModule,
        FormaPagamentoSelectModule
    ],
    declarations: [
        ClienteFinanceiroFormComponent
    ],
    exports: [
        ClienteFinanceiroFormComponent
    ]
})
export class ClienteFinanceiroFormModule { }
